import { Users, TrendingUp } from 'lucide-react';

const Hero = () => {
    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const offset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section id="about" className="pt-32 pb-16 bg-gradient-to-br from-abmer-50 to-sky-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                            Building Financial Security Through Community Partnership
                        </h2>
                        <p className="text-lg text-gray-700 mb-8">
                            Sagwara Apni Bachat Ghar Mahila Sahakari Samiti Limited is a multi-state credit co-operative society dedicated to empowering members through accessible savings and loan products. We believe in member ownership, transparent governance, and community-focused financial services.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={() => scrollToSection('membership')}
                                className="px-6 py-3 bg-amber-900 text-white rounded-lg font-semibold hover:bg-amber-950 transition-colors flex items-center justify-center"
                            >
                                <Users className="mr-2" size={20} />
                                Become a Member
                            </button>
                            <button
                                onClick={() => scrollToSection('products')}
                                className="px-6 py-3 bg-yellow-700 text-white rounded-lg font-semibold hover:bg-yellow-800 transition-colors flex items-center justify-center"
                            >
                                <TrendingUp className="mr-2" size={20} />
                                View Products
                            </button>
                        </div>
                    </div>

                    <div className="bg-white rounded-2xl shadow-xl p-8">
                        <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Sagwara Apni Bachat Ghar Mahila Sahakari Samiti Limited?</h3>
                        <div className="space-y-4">
                            <div className="flex items-start">
                                <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center text-amber-900 font-bold mr-3 flex-shrink-0">
                                    1
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900">Member-Owned Structure</h4>
                                    <p className="text-sm text-gray-600">Every member is an owner with voting rights and access to benefits</p>
                                </div>
                            </div>
                            <div className="flex items-start">
                                <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center text-amber-900 font-bold mr-3 flex-shrink-0">
                                    2
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900">Competitive Returns</h4>
                                    <p className="text-sm text-gray-600">Attractive interest rates on deposits and affordable loan products</p>
                                </div>
                            </div>
                            <div className="flex items-start">
                                <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center text-amber-900 font-bold mr-3 flex-shrink-0">
                                    3
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900">Community Focus</h4>
                                    <p className="text-sm text-gray-600">Supporting local economic development and financial inclusion</p>
                                </div>
                            </div>
                            <div className="flex items-start">
                                <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center text-amber-900 font-bold mr-3 flex-shrink-0">
                                    4
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900">Transparent Governance</h4>
                                    <p className="text-sm text-gray-600">Democratic decision-making and regular audits ensure accountability</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
